/**
 * Created by Carsten Bühler
 * User: CBuehler on 05.09.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import L from 'external/leaflet';
import React from 'external/react';
import PropTypes from 'external/prop-types';
import {
    AppContext,
    ConfigActions,
    debounce,
    getLocalConfigStore,
    shallowEqual
} from 'plugin/liferay-widgets-react-web';
import { getPropertiesFromLocalConfig } from '../utils/local-config-util';
import { LayerChooserSidebar } from '../map-portlet';
import ReactDOM from 'external/react-dom';

const LocalConfigStore = getLocalConfigStore(AppContext);

export default class LayerChooserPlugin {

    constructor(props, config) {
        this.config = config;
        this.props = props;
        this.portletConfig = undefined;
        this.updateTitle = this.updateTitle.bind(this);
        this.onLayersChange = debounce(this.onLayersChange.bind(this), 300);

    }

    withCtx(s) {
        return (this.context && this.context.contextId ? this.context.contextId : 'DEFAULT_') + s;
    }

    _getLocalStorageKeyWithMapConfig(key) {
        if (this.context && this.context.contextId) {
            const mapConf = this.context;
            key += '_MAP_CONFIG_' + mapConf.contextId;
        }
        return key;
    }

    initOptions(o) {
        this.o = o;
        this.ACTIVE_LAYER_UUIDS_KEY = this.withCtx('_ACTIVE_UUIDS');
        // Portlet config overrides default behaviour. See FLIWASEN-45 https://inovum-dev.de/jira/browse/FLIWASEN-45
        if (o && o.portletConfig && o.portletConfig.activeLayerUuids) {
            this.portletConfig = o.portletConfig;
            ConfigActions.updateLocalConfig(this._getLocalStorageKeyWithMapConfig(this.ACTIVE_LAYER_UUIDS_KEY), o.portletConfig.activeLayerUuids);
        }

        return this.options(o);
    }

    init(map, o, reEvaluate) {
        this.reEvaluate = reEvaluate;
        this.map = map;
        const sidebarContent = L.DomUtil.create('div', '', map.getContainer());
        const btn = L.DomUtil.create('div', 'sidebar-btn left');
        btn.setAttribute('role', 'button');
        btn.setAttribute('title', 'Themen & Lagekarten');
        this.btnContent = L.DomUtil.create('div', 'sidebar-btn__content', btn);
        this.sidebar = L.control.sidebar(sidebarContent, { position: 'left', closeButton: false });

        this.sidebar.on('show', this.updateTitle);
        this.sidebar.on('hide', this.updateTitle);
        this.updateTitle();

        map.addControl(this.sidebar);
        const content = this.sidebar.getContainer();
        btn.onclick = (e) => {
            L.DomEvent.stopPropagation(e);
            L.DomEvent.preventDefault(e);
            this.sidebar.toggle();
        };
        content.parentNode.insertBefore(btn, content);
    }

    options(o) {

        let defaultActiveUUids = this.config && this.config.initShowAllLayers ? null : [];

        const localStorageOrDefault = getPropertiesFromLocalConfig(LocalConfigStore.getLocalConfig(this._getLocalStorageKeyWithMapConfig(this.ACTIVE_LAYER_UUIDS_KEY)), defaultActiveUUids);

        if (o.portletConfig && this.portletConfig && !shallowEqual(o.portletConfig.activeLayerUuids, this.portletConfig.activeLayerUuids)) {
            this.portletConfig = o.portletConfig;
            ConfigActions.updateLocalConfig(this._getLocalStorageKeyWithMapConfig(this.ACTIVE_LAYER_UUIDS_KEY), o.portletConfig.activeLayerUuids);
            o = {
                ...o,
                activeUuids: o.portletConfig.activeLayerUuids
            };
        } else if (!shallowEqual(o.activeUuids, localStorageOrDefault)) {
            if (o.activeUuids || localStorageOrDefault) {
                console.debug('Extend activeUuids from options', o.activeUuids, ' with', { localStorageOrDefault });
                o = {
                    ...o,
                    activeUuids: {
                        ...o.activeUuids,
                        ...localStorageOrDefault
                    }
                };
            }
        }

        return o;
    }

    updateTitle() {
        const icon = this.sidebar.isVisible() ? 'right' : 'left';
        this.btnContent.innerHTML = '<span class="sidebar-situationmap-name">' + 'Themen & Lagekarten' + '</span>' + '<span class="icon icon-fliwas-arrow-' + icon + ' left" title=""></span>';
    }

    update(map, o) {
        this.o = o;
        ReactDOM.render(
            <LayerChooserSidebar
                layerDescriptions={ o.layerDescriptions }
                onClose={ () => this.sidebar.hide() }
                context={ this.context }
                onLayersChange={ this.onLayersChange }
                activeLayerUuids={ this.o.activeUuids }
                reEvaluate={ this.reEvaluate }
            />,
            this.sidebar.getContainer()
        );
    }

    remove() {
        this.map = null;
    }

    onLayersChange(activeUuids) {
        ConfigActions.updateLocalConfig(this._getLocalStorageKeyWithMapConfig(this.ACTIVE_LAYER_UUIDS_KEY), activeUuids);
        this.reEvaluate({ activeUuids });
    }
}

LayerChooserPlugin.contextTypes = {
    contextId: PropTypes.string
};



// WEBPACK FOOTER //
// ./js/plugins/LayerChooserPlugin.js